module.exports = __webpack_public_path__ + "components/flag/static/square/kp-ffeb99c301c28c515dc0c091777c96b5.svg";